import { render } from "./ProceedPopup.vue?vue&type=template&id=f84f7086&scoped=true"
import script from "./ProceedPopup.vue?vue&type=script&lang=js"
export * from "./ProceedPopup.vue?vue&type=script&lang=js"

import "./ProceedPopup.vue?vue&type=style&index=0&id=f84f7086&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84f7086"]])

export default __exports__